import Component from './component';
import header from '../header';

/**
 * Header component
 */
export default class HeaderMenu extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }

    enable() {
        this.$el.html(this.state.data);
        header.init();
        let languageSelectorComp = $('[data-comp="LanguageSelector"]');
        if (this.$el.find('[data-comp="LanguageSelector"]').length) {
            // if mobile menu has languageselector component
            languageSelectorComp = this.$el.find('[data-comp="LanguageSelector"]');
        }
        if (languageSelectorComp.length) {
            // mount component after header component is loaded
            languageSelectorComp.removeClass('enabled');
            window.PVH.mountAllComponents('LanguageSelector');
        }
    }
}
